import { render, staticRenderFns } from "./PublicOrderDetails.vue?vue&type=template&id=7318875f&scoped=true"
import script from "./PublicOrderDetails.vue?vue&type=script&lang=js"
export * from "./PublicOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicOrderDetails.vue?vue&type=style&index=0&id=7318875f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318875f",
  null
  
)

export default component.exports